export var Period;
(function (Period) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Period["Year"] = "Year";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Period["Quarter"] = "Quarter";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Period["Month"] = "Month";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Period["Daily"] = "Daily";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Period["D260"] = "D260";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Period["D252"] = "D252";
})(Period || (Period = {}));
//# sourceMappingURL=Period.js.map